import { Amplify } from 'aws-amplify';
import { STRATA_COGNITO_CONFIG } from '../../config/bootstrap';

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: STRATA_COGNITO_CONFIG.USER_POOL_ID,
        userPoolClientId: STRATA_COGNITO_CONFIG.CLIENT_ID,
        loginWith: {
          oauth: {
            domain: STRATA_COGNITO_CONFIG.DOMAIN,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [window.location.origin + '/auth/strata/callback'],
            redirectSignOut: [window.location.origin],
            responseType: 'code'
          }
        }
      }
    }
  });
};
